import { Avatar, Button, IconButton, Stack, Typography } from '@mui/material';
import FeatherIcon from 'feather-icons-react';
import React from 'react';
import { colours as constColours, CustomTooltip, InfoTooltip } from '../../consts';
import { THEME_MODES } from '../../helpers/constant';
import { useThemeMode } from '../theme';

const CardHeaderTitle = ({
    title,
    icon = null,
    tooltip = null,
    viewDetailTitle = null,
    viewDetailAction = null
}) => {
    const { colours, themeMode, FONT } = useThemeMode();

    return (
        <Stack direction="row" alignItems="center" gap={1}>
            {icon && (
                <Avatar
                    sx={(theme) => ({
                        bgcolor: theme.palette.mode === THEME_MODES.LIGHT ? colours.white : constColours.black,
                        color: colours.subduedgray,
                        border: `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.grayDisabled
                            }`,
                    })}
                >
                    <FeatherIcon icon={icon} size={20} />
                </Avatar>
            )}

            <Typography
                variant="h6"
                component="div"
                fontWeight={600}
            >
                <Typography
                    component="span"
                    variant='inherit'
                    marginRight={.5}
                >
                    {title}
                </Typography>
                {tooltip && <InfoTooltip info={tooltip} themeMode={themeMode} />}

                {viewDetailTitle && viewDetailAction && (
                    themeMode === THEME_MODES.COLOR_VISION ?
                        <Button
                            variant="text"
                            size="small"
                            onClick={viewDetailAction}
                            endIcon={<FeatherIcon icon="chevron-right" size={18} />}
                            sx={{
                                padding: 0,
                                textDecoration: "underline",
                                fontSize: FONT.SIZE_12,
                                fontWeight: 400,
                                color: colours.black,
                                marginTop: -.25,
                                '.MuiButton-endIcon': {
                                    ml: 0,
                                }
                            }}
                        >
                            {viewDetailTitle}
                        </Button>
                        :
                        <CustomTooltip title={viewDetailTitle}>
                            <IconButton
                                aria-label={viewDetailTitle}
                                size="small"
                                color="primary"
                                sx={{
                                    padding: .25,
                                    marginTop: -.25,
                                    marginLeft: -.25,
                                }}
                                onClick={viewDetailAction}
                            >
                                <FeatherIcon icon="chevron-right" size={20} />
                            </IconButton>
                        </CustomTooltip>
                )}
            </Typography>
        </Stack>
    );
};

export default CardHeaderTitle;